import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { styles } from '4all-ui/styles';

const Icon = styled.svg`
  ${({ absolute, isOpen }) => {
    let transform = 'transform:';
    let css = '';

    if (absolute) {
      transform += ' translateY(-50%)';
      css += `
        position: absolute;
        right: 10px;
        top: 50%;
      `;
    }

    if (isOpen) {
      transform += ' rotate(-180deg)';
    }

    return `
      ${css}
      ${transform};
    `;
  }}

  display: block;
  pointer-events: none;
  transition: transform 300ms ease;
`;

const ArrowIcon = ({ size, color, className, absolute, isOpen, disabled, id }) => (
  <Icon
    width={size}
    height={size}
    id={id}
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    className={`arrow-icon ${className}`}
    absolute={absolute}
    isOpen={isOpen}
    disabled={disabled}
  >
    <defs>
      <path
        d="M14.8273272,6.76005993 C15.2359848,6.388553 15.8684331,6.41866959 16.2399401,6.82732721 C16.611447,7.23598482 16.5813304,7.86843315 16.1726728,8.23994007 L10.6726728,13.2399401 C10.2912516,13.5866866 9.70874843,13.5866866 9.32732721,13.2399401 L3.82732721,8.23994007 C3.41866959,7.86843315 3.388553,7.23598482 3.76005993,6.82732721 C4.13156685,6.41866959 4.76401518,6.388553 5.17267279,6.76005993 L10,11.1485392 L14.8273272,6.76005993 Z"
        id="arrow-icon-1"
      />
    </defs>
    <g id="Library-" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon/chevron/down/">
        <mask id="arrow-icon-2" fill="white">
          <use xlinkHref="#arrow-icon-1" />
        </mask>
        <use id="chevron-down" fill="#979797" fillRule="nonzero" xlinkHref="#arrow-icon-1" />
        <g
          id="colors/portal_unico/grey3"
          mask="url(#arrow-icon-2)"
          fill={disabled ? styles.colors.GRAY_MEDIUM : color}
        >
          <rect id="color" x="0" y="0" width="20" height="20" />
        </g>
      </g>
    </g>
  </Icon>
);

ArrowIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  absolute: PropTypes.bool,
  isOpen: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
};

ArrowIcon.defaultProps = {
  size: '20px',
  color: styles.colors.MAIN_COLOR,
  className: '',
  absolute: true,
  isOpen: false,
  disabled: false,
  id: '',
};

export default ArrowIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/ArrowIcon/index.js